// extracted by mini-css-extract-plugin
module.exports = {"HomeSliderWrapper":"HomeSliderWrapper_HomeSliderWrapper__4Jd7S"};